exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".active_tab {\n  color: #0053a6 !important;\n  opacity: 1 !important;\n}\n", ""]);

